/**
 * Shared date formatting — ISO 8601, 24-hour time.
 *
 * This is the ONLY place date formatting should happen.
 * Import from here instead of writing local formatDate functions.
 */

/** Date only: "2026-03-18" */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return new Date(date).toISOString().split('T')[0];
}

/** Date + time: "2026-03-18 14:05" */
export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '—';
  const d = new Date(date);
  const datePart = d.toISOString().split('T')[0];
  const timePart = d.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${datePart} ${timePart}`;
}

/** Relative: "Today", "Yesterday", "Mon", "2026-03-18" */
export function formatRelativeDate(date: string | Date | null | undefined): string {
  if (!date) return '—';
  const d = new Date(date);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - d.getTime()) / 86400000);

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return d.toLocaleDateString('en-GB', { weekday: 'short' });
  return formatDate(date);
}
